import { useEffect, useRef } from 'react';

export function usePrevious<V>(value: V): V | undefined {
  const prevRef = useRef<V | undefined>();

  useEffect(() => {
    prevRef.current = value;
  });

  // eslint-disable-next-line react-hooks/refs
  return prevRef.current;
}
